<template>
  <div class="l-product__row">
    <div class="l-product__imgCol">
      <swiper
        class="swiper productSwiper"
        :options="productSwiper"
        v-if="selectedVariation && !showFullsize"
        ref="productSwiper"
        @swiper="setSmallSwiper"
      >
        <swiper-slide
          class="productSwiper-slide"
          v-for="(slide, index) in selectedVariation.slides"
          :key="index"
          @click.native="maximise(index)"
        >
          <img src="placeholder" :srcset="slide.large" :alt="slide.alt" />
        </swiper-slide>
        <div class="product-swiper-prev swiper-button-prev" slot="button-prev">
          <slot name="prevbuttonsvg"></slot>
        </div>
        <div class="product-swiper-next swiper-button-next" slot="button-next">
          <slot name="nextbuttonsvg"></slot>
        </div>
      </swiper>
      <div
        class="product-swiper-pagination swiper-pagination"
        slot="pagination"
      ></div>
      <swiper
        class="swiper productThumbsSwiper"
        :options="productThumbsSwiper"
        v-if="selectedVariation && !showFullsize"
        ref="productThumbsSwiper"
      >
        <swiper-slide
          class="productThumbsSwiper-slide"
          v-for="(thumb, index) in selectedVariation.slides"
          :key="index"
        >
          <img :src="placeholder" :srcset="thumb.thumb" :alt="thumb.alt" />
        </swiper-slide>
      </swiper>
    </div>
    <div class="l-product__dataCol">
      <slot name="info"></slot>

      <div class="l-product__addToCart">
        <div class="l-product__variations">
          <div
            class="l-product__variations-item"
            v-for="variant in variants"
            :key="variant.id"
          >
            <input
              name="purchasableId"
              v-model="selectedVariation"
              type="radio"
              :id="'variant-' + variant.id"
              :value="variant"
            />
            <label :for="'variant-' + variant.id">
              <img :src="variant.image.url" />
            </label>
          </div>
        </div>

        <div class="l-product__selectedVariation">
          Variation: <span>{{ selectedVariation.title }}</span>
        </div>

        <div
          class="l-product__price"
          v-if="showPrice"
          v-html="selectedVariation.price"
        ></div>

        <form class="l-product__form">
          <slot name="form"></slot>
          <qty-spinner
            :min="spinnerMin"
            :value="spinnerMin"
            :step="1"
            v-model="qty"
          ></qty-spinner>
          <div class="o-btn o-btn--filled o-btn--expand" @click="addToCart()">
            <div>Add to inquiry</div>
          </div>
        </form>

        <transition name="fade">
          <div
            class="o-addtocartmodal__bg"
            v-if="showModal"
            @click="closeModal()"
          ></div>
        </transition>

        <transition name="fade">
          <div class="o-addtocartmodal" v-if="showModal">
            <div class="o-addtocartmodal__loader" v-if="addingToCart">
              <slot name="loader"></slot>
            </div>
            <div class="o-addtocartmodal__close" @click="closeModal()">
              <img src="/images/close.svg" />
            </div>
            <div class="o-addtocartmodal__header">
              <img src="/images/success.svg" />
              Product successfully added to inquiry list
            </div>
            <div class="o-addtocartmodal__data">
              <div class="o-addtocartmodal__data-left">
                <img :src="selectedVariation.imageXl.url" />
              </div>
              <div class="o-addtocartmodal__data-right">
                <div class="title">
                  {{ title }}
                </div>
                <div class="description">
                  {{ description }}
                </div>
                <div class="variation valueLabel">
                  <div class="label">Variant:</div>
                  <div>
                    {{ selectedVariation.title }}
                  </div>
                </div>
                <div class="qty valueLabel">
                  <div class="label">Quantity:</div>
                  <div>
                    {{ qty }}
                  </div>
                </div>
              </div>
            </div>
            <div class="o-addtocartmodal__buttons">
              <div
                @click="closeModal()"
                class="o-btn o-addtocartmodal__buttons__continue"
              >
                Continue shopping
              </div>
              <a :href="carturl" class="o-btn o-btn--filled"
                >Proceed to inquiry list</a
              >
            </div>
          </div>
        </transition>
      </div>

      <!-- <div
        class="l-product__stockstatus"
        :class="'l-product__stockstatus--' + stockStatus.status"
        v-if="stockStatus"
      >
        <div class="indicator"></div>
        <div class="text">
          {{ stockStatus.text }}
        </div>
      </div> -->

      <div class="l-product__ctas">
        <slot name="cta"></slot>
      </div>
    </div>

    <transition name="fade" mode="in-out">
      <div
        v-if="showFullsize"
        class="c-product__fullsize"
        @keydown.esc="closeLargeImage"
        tabindex="0"
      >
        <div class="close" @click="closeLargeImage">
          <svg viewBox="0 0 200 200">
            <path
              class="cls-1"
              d="M156.1377,106.5757H43.8389a5.5,5.5,0,0,1,0-11H156.1377a5.5,5.5,0,0,1,0,11Z"
            />
            <path
              class="cls-1"
              d="M99.9883,162.7251a5.5006,5.5006,0,0,1-5.5-5.5V44.9262a5.5,5.5,0,0,1,11,0V157.2251A5.5006,5.5006,0,0,1,99.9883,162.7251Z"
            />
          </svg>
        </div>
        <swiper
          class="swiper fullsizeSwiper"
          :options="fullsizeSwiper"
          v-if="selectedVariation"
          ref="fullsizeSwiper"
          @swiper="setLargeSwiper"
        >
          <swiper-slide
            class="fullsizeSwiper-slide"
            v-for="(slide, index) in selectedVariation.slides"
            :key="index"
          >
            <img src="placeholder" :srcset="slide.xlarge" :alt="slide.alt" />
          </swiper-slide>
          <div
            class="fullsize-swiper-prev swiper-button-prev"
            slot="button-prev"
          >
            <slot name="prevbuttonsvg"></slot>
          </div>
          <div
            class="fullsize-swiper-next swiper-button-next"
            slot="button-next"
          >
            <slot name="nextbuttonsvg"></slot>
          </div>
        </swiper>
        <div class="fullsizeThumbsSwiper__wrapper">
          <swiper
            class="swiper fullsizeThumbsSwiper"
            :options="fullsizeThumbsSwiper"
            v-if="selectedVariation"
            ref="fullsizeThumbsSwiper"
          >
            <swiper-slide
              class="fullsizeThumbsSwiper-slide"
              v-for="(thumb, index) in selectedVariation.slides"
              :key="index"
            >
              <img :src="placeholder" :srcset="thumb.thumb" :alt="thumb.alt" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import QtySpinner from "./QtySpinner.vue";
import axios from "axios";

export default {
  name: "Product",
  components: {
    QtySpinner,
  },
  data() {
    return {
      qty: 1,
      showModal: false,
      selectedVariation: this.variants[0],
      addingToCart: false,
      showFullsize: false,
      showLargeThumbs: false,
      initialSlide: 0,
      smallSwiper: null,
      largeSwiper: null,

      productSwiper: {
        loop: false,
        slidesPerView: 1,
        initialSlide: 0,
        // loopedSlides: this.variants[0].slides.length,
        grabCursor: true,
        effect: "fade",
        navigation: {
          nextEl: ".product-swiper-next",
          prevEl: ".product-swiper-prev",
        },
        pagination: {
          el: ".product-swiper-pagination",
        },
      },
      productThumbsSwiper: {
        loop: false,
        // loopedSlides: this.variants[0].slides.length,
        centeredSlides: false,
        initialSlide: 0,
        spaceBetween: 0,
        slidesPerView: 1,
        slideToClickedSlide: true,
        allowTouchMove: false,
      },

      fullsizeSwiper: {
        slidesPerView: 1,
        grabCursor: true,
        initialSlide: this.initialSlide,
        navigation: {
          nextEl: ".fullsize-swiper-next",
          prevEl: ".fullsize-swiper-prev",
        },
      },
      fullsizeThumbsSwiper: {
        initialSlide: this.initialSlide,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        spaceBetween: 10,
        allowTouchMove: false,
      },
    };
  },
  props: {
    placeholder: String,
    variants: Array,
    csrf: String,
    title: String,
    subheading: String,
    description: String,
    showPrice: Number,
    carturl: String,
  },
  computed: {
    spinnerMin: function () {
      if (this.selectedVariation.minQty) {
        return this.selectedVariation.minQty;
      }

      return 1;
    },
    stockStatus: function () {
      if (!this.selectedVariation) {
        return false;
      }

      if (this.selectedVariation.isAvailable) {
        return {
          status: "local",
          text: "In stock (estimated delivery time 5-7 work days)",
        };
      }

      if (!this.selectedVariation.isAvailable) {
        return {
          status: "outOfStock",
          text: "Out of stock. Contact our sales department for info about coming productions.",
        };
      }
    },
  },
  watch: {
    selectedVariation: function (val, oldVal) {
      // this.productSwiper.loopedSlides = val.slides.length
      // this.productThumbsSwiper.loopedSlides = val.slides.length
      this.$refs.productSwiper.$swiper.slideTo(0);
      if (val.minQty > this.qty) {
        this.qty = val.minQty;
      }
    },
  },
  methods: {
    maximise: function (index) {
      this.fullsizeSwiper.initialSlide = index;
      this.fullsizeThumbsSwiper.initialSlide = index;
      this.showFullsize = true;

      this.$nextTick(() => {
        const fullsizeSwiper = this.$refs.fullsizeSwiper.$swiper;
        const fullsizeThumbsSwiper = this.$refs.fullsizeThumbsSwiper.$swiper;
        fullsizeSwiper.controller.control = fullsizeThumbsSwiper;
        fullsizeThumbsSwiper.controller.control = fullsizeSwiper;
      });
    },
    closeLargeImage: function () {
      this.productSwiper.initialSlide =
        this.$refs.fullsizeSwiper.$swiper.activeIndex;
      this.productThumbsSwiper.initialSlide =
        this.$refs.fullsizeSwiper.$swiper.activeIndex;
      this.showFullsize = false;

      this.$nextTick(() => {
        const productSwiper = this.$refs.productSwiper.$swiper;
        const productThumbsSwiper = this.$refs.productThumbsSwiper.$swiper;
        productSwiper.controller.control = productThumbsSwiper;
        productThumbsSwiper.controller.control = productSwiper;
      });
    },
    setLargeSwiper(swiper) {
      this.largeSwiper = swiper;
    },
    setSmallSwiper(swiper) {
      this.smallSwiper = swiper;
    },
    addToCart() {
      this.addingToCart = true;
      this.showModal = true;
      const formData = new FormData();
      formData.append("action", "quantity-extensions/cart/update-cart");
      formData.append("CRAFT_CSRF_TOKEN", this.csrf);
      formData.append("qty", this.qty);
      formData.append("purchasableId", this.selectedVariation.id);

      axios
        .post(document.location.href, formData)
        .then((response) => {
          this.addingToCart = false;
          this.$store.commit("setCart", response.data.cart);
        })
        .then()
        .catch((error) => {});
    },
    closeModal() {
      if (this.addingToCart) {
        return;
      }

      this.showModal = false;
      (this.qty = 1), (this.selectedVariation = this.variants[0]);
    },
  },
  mounted() {
    this.$nextTick(() => {
      const productSwiper = this.$refs.productSwiper.$swiper;
      const productThumbsSwiper = this.$refs.productThumbsSwiper.$swiper;
      productSwiper.controller.control = productThumbsSwiper;
      productThumbsSwiper.controller.control = productSwiper;
    });
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.l-product {
  &__imgCol {
    height: 100%;
    position: relative;
    overflow: hidden;

    .productSwiper {
      background-color: #ededed;
      .swiper {
        &-slide {
          text-align: center;
          background-color: #ededed;
          cursor: zoom-in;
        }

        &-button {
          &-disabled {
            pointer-events: all;
            &:hover {
              svg {
                path {
                  fill: $c-white !important;
                }
              }
            }
          }
          &-next,
          &-prev {
            &::after {
              display: none;
            }
            width: 52px;
            height: 57px;

            svg {
              path {
                transition: $t-hover;
              }
            }

            &:hover {
              svg {
                path {
                  fill: $brand-orange;
                  transition: $t-hover;
                }
              }
            }
          }
          &-next {
            right: 0;
          }
          &-prev {
            left: 0;
          }
        }
      }
    }

    .swiper-pagination {
      position: static;
      display: none;
      margin: 0 auto;
      margin-top: 25px;
      width: calc(100% - 77px);
      align-items: center;
      justify-content: center;
      &-bullet {
        height: 4px;
        border-radius: 0;
        display: flex;
        flex-grow: 1;

        &-active {
          background-color: $brand-orange;
        }
      }
    }

    .productThumbsSwiper {
      padding-top: 25px;
      width: 94px;
      margin-left: 0;
      margin-right: 0;
      overflow: visible;
      .swiper {
        &-wrapper {
          // margin-left: -25%;
        }
        &-container {
          width: 94px;
        }
        &-slide {
          height: 94px;
          width: 94px !important;

          opacity: 0.5;
          transition: $t-hover;

          &-active {
            opacity: 1;
          }

          img {
            background-color: #ededed;
            width: 84px;
          }
        }
      }
    }
  }
}

.c-product__fullsize {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  max-height: 100vh;
  z-index: 30;
  background-color: #ededed;

  .fullsizeSwiper {
    .swiper {
      &-slide {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 100vh;
          width: auto;
          object-fit: contain;
        }
      }
      &-button {
        &-next,
        &-prev {
          &::after {
            display: none;
          }
          width: 52px;
          height: 57px;

          svg {
            path {
              transition: $t-hover;
            }
          }

          &:hover {
            svg {
              path {
                fill: $brand-orange;
                transition: $t-hover;
              }
            }
          }
        }
        &-next {
          right: 30px;
        }
        &-prev {
          left: 30px;
        }
      }
    }
  }

  .fullsizeThumbsSwiper {
    width: 100vw;
    &__wrapper {
      position: absolute;
      bottom: 30px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      width: 100%;
    }

    .swiper {
      z-index: 40;
      width: 90%;
      &-slide {
        height: 84px;
        width: 84px;
        background-color: $c-white;

        img {
          width: 84px;
        }
      }
    }
  }

  .close {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 40;
    width: 52px;
    height: 52px;
    font-size: 20px;
    background-color: $c-white;
    transition: all $t-nice 0.3s;
    cursor: pointer;

    svg {
      transform: rotate(45deg);
      path {
        transition: all $t-nice 0.3s;
        fill: $brand-light-grey;
      }
    }

    &:hover {
      background-color: $brand-orange;
      svg {
        path {
          fill: $c-white;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .l-product {
    &__imgCol {
      width: 100%;

      .productSwiper {
        background-color: #ededed;
        .swiper {
          &-slide {
            display: flex;
            justify-content: center;
            background-color: #ededed;
          }

          &-button {
            &-next,
            &-prev {
              display: none;
            }
            &-next {
              right: 0;
            }
            &-prev {
              left: 0;
            }
          }
        }
      }

      .swiper-pagination {
        display: flex;
      }

      .productThumbsSwiper {
        display: none;
      }
    }
    .fullsizeSwiper {
      .swiper {
        &-button {
          &-next,
          &-prev {
            display: none;
          }
        }
      }
    }
  }
}
</style>
